
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/framework-strategy",
      function () {
        return require("private-next-pages/download/framework-strategy/index.tsx");
      }
    ]);
  